<template>
  <div>
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Подписанные приходы</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <RoamingInvoiceList ref="roamingInvoiceList"
                        :invoices="dataTable.invoices"
                        :total="dataTable.total"
                        :limitOptions="dataTable.limitOptions"
                        :filters.sync="dataTable.filters"
                        :pagination.sync="dataTable.pagination"
                        :allow-sign-all-button="false"
                        :allow-sign-button-fn="allowSignButton"
                        :allow-decline-button-fn="allowDeclineButton"
                        :disable-not-allowed-sign-button="false"
                        :disable-not-allowed-decline-button="false"
                        :allow-download-green-list-button="true"
                        :allow-signed-date-filter="true"
                        :allow-branch-filter="true"
                        :show-created-at="true"
                        @load="onLoad"
                        @download-green-list="onDownloadGreenList"
                        @download-green-list-by-certificate="onDownloadGreenList"
    />

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import RoamingInvoiceList from '@/components/main/roaming/RoamingInvoiceList'
import InvoiceService from '@/services/invoice.service'
import _ from 'underscore'
import moment from 'moment'

export default {
  components: {
    RoamingInvoiceList
  },
  name: "RoamingIncomeSignedBox",

  data() {
    return {
      dataTable: {
        invoices: [],
        total: 0,
        limitOptions: [10, 20, 30, 50, 100, 200, 500],
        filters: {
          invoiceNumber: '',
          invoiceDate: null,
          contractor: '',
          signedDate: null,
          branch: null
        },
        pagination: {
          page: 1,
          limit: 10
        }
      },

      loading: false
    };
  },

  methods: {
    /*handlers*/
    onLoad() {
      this.load();
    },
    onDownloadGreenList(serial) {
      this.loading = true;

      let skip = (this.dataTable.pagination.page - 1) * this.dataTable.pagination.limit;
      skip = skip < 0 ? 0 : skip;

      InvoiceService.downloadRoamingIncomeSignedGreenList({
        limit: this.dataTable.pagination.limit,
        skip: skip,
        contractor: this.dataTable.filters.contractor,
        invoiceDate: this.dataTable.filters.invoiceDate ? moment(this.dataTable.filters.invoiceDate, 'YYYY-MM-DD') : null,
        invoiceNumber: this.dataTable.filters.invoiceNumber,
        signedDate: this.dataTable.filters.signedDate ? moment(this.dataTable.filters.signedDate, 'YYYY-MM-DD') : null,
        branch: this.dataTable.filters.branch ? this.dataTable.filters.branch.id : null,
        serial: serial
      })
          .finally(() => {
            this.loading = false;
          });
    },

    allowSignButton() {
      return false;
    },
    allowDeclineButton() {
      return false;
    },

    load() {
      this.loading = true;

      let skip = (this.dataTable.pagination.page - 1) * this.dataTable.pagination.limit;
      skip = skip < 0 ? 0 : skip;

      InvoiceService.roamingIncomeSignedDocumentsMeta({
        limit: this.dataTable.pagination.limit,
        skip: skip,
        contractor: this.dataTable.filters.contractor,
        invoiceDate: this.dataTable.filters.invoiceDate ? moment(this.dataTable.filters.invoiceDate, 'YYYY-MM-DD') : null,
        invoiceNumber: this.dataTable.filters.invoiceNumber,
        signedDate: this.dataTable.filters.signedDate ? moment(this.dataTable.filters.signedDate, 'YYYY-MM-DD') : null,
        branch: this.dataTable.filters.branch ? this.dataTable.filters.branch.id : null
      })
          .then(response => {
            if (this.loading) {
              this.dataTable.invoices = _.map(response.data.Records, i => {
                return {
                  documentUniqueId: i.DocumentUniqueId,
                  invoiceNumber: i.InvoiceNumber,
                  invoiceDate: i.InvoiceDate,
                  invoiceTotal: i.InvoiceTotal,
                  contractorInn: i.ContractorInn,
                  contractorName: i.ContractorName,
                  actNumber: i.ActNumber,
                  branchName: i.BranchName,
                  signedOn: i.SignedOn ? moment(i.SignedOn) : null,
                  createdOn: i.CreatedAt
                };
              });
              this.dataTable.total = response.data.Total;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
  }
}
</script>

<style scoped>

</style>